module.exports = __webpack_public_path__ + "img/liberty.a9034915.png";